import { useCallback, useEffect, useState } from 'react'
import {
  Form,
  FormFeedback,
  Spinner,
  Alert
  // @ts-ignore
} from 'reactstrap'
import { useForm } from 'react-hook-form'
//@ts-ignore
import Select from 'react-select'
import moment from 'moment'
//@ts-ignore
import classnames from 'classnames'
//@ts-ignore
import { selectThemeColors } from '@utils'
import mapper from '../../_endpoints'
import { useItemsHook } from '../../_hooks/_index'
import SupportTicket from './SupportTicket'
import { useSupportService } from '../../_services/SupportService'
import { ContentWrapper, DeleteIcon, Header, Image, ImgContainer, Main, StyledCard } from './styles'
import { Dropzone } from '../components/dropzone'
import { usePost } from '../../_hooks/usePost'
import { SpinnerWrapper } from '../../styles/common'
import { FileRejection } from 'react-dropzone'
import { Messages } from '../components/dropzone/constants'
import { v4 as uuid } from 'uuid'
//@ts-ignore
import { Button, Input, Textarea } from 'dsm-react-lib'
import { useSasToken } from '../../_hooks/useSasToken'
import { FAQPage } from '@configs/constants'

const options = [
  { value: 'Centrali', label: 'Centrali' },
  { value: 'Data Marketplace', label: 'Data Marketplace' },
  { value: 'Specific Application', label: 'Specific Application' }
]

const issueCategoryOptions = [
  { value: 'Access Related', label: 'Access Related' },
  { value: 'Data Issue', label: 'Data Issue' },
  { value: 'Technical Issue', label: 'Technical Issue' },
  { value: 'General Help', label: 'General Help' }
]

const MAX_FILES = 5

const SupportForm = () => {
  const validationMessages = {
    subject: 'Subject is required.',
    description: 'Description is required.'
  }

  const { register, errors, trigger, handleSubmit } = useForm({})

  const { isSending, raiseTicket } = useSupportService()
  const [subject, setSubject] = useState('')
  const [isSent, setIsSent] = useState(false)
  const [description, setDescription] = useState('')
  const [application, setApplication] = useState<any>()
  const [applicationOptions, setApplicationOptions] = useState<any[]>([])
  const [supportId, setSupportId] = useState<string>('')
  const [errorMessage, setErrorMessage] = useState('')
  const [screenshotError, setScreenshotError] = useState('')
  const [option, setOption] = useState<any>()
  const [issueCategory, setIssueCategory] = useState<any>()
  const [disableButton, setDisableButton] = useState(false)
  const [screenshots, setScreenshots] = useState<any[]>([])
  const [hasError, setHasError] = useState(false)
  const [isUploadingScreenshots, postScreeshots] = usePost()
  const { appendToken } = useSasToken('userfiles')

  const { displayName: name } = JSON.parse(localStorage.getItem('userInfoData') || '')

  const [{ items: newArrivals }] = useItemsHook(mapper.applications.get)

  useEffect(() => {
    if (newArrivals) {
      setApplicationOptions(
        newArrivals
          .map((application: any) => ({
            ...application,
            value: application.name,
            label: application.name,
            id: application.id
          }))
          .sort((a, b) => a.name.toLowerCase().localeCompare(b.label.toLowerCase()))
      )
    }
  }, [newArrivals])

  const onSubjectChange = (e: any) => {
    setSubject(e.target.value)
  }

  const onDescChange = (e: any) => {
    setDescription(e.target.value)
  }

  const onOptionChange = (e: any) => {
    if (e === null) {
      setOption(undefined)
      setApplication(undefined)
      setIssueCategory(undefined)
    } else {
      setOption({ label: e.label, value: e.value })
      if (e.label === 'Centrali' || e.label === 'Data Marketplace') {
        setApplication({ label: e.label, value: e.value, id: 0 })
      } else {
        setApplication(undefined)
      }

      if (e.label !== 'Data Marketplace') {
        setIssueCategory(undefined)
      }
    }
  }

  const onIssueCategoryChange = (e: any) => {
    if (e === null) setIssueCategory(undefined)
    else setIssueCategory({ label: e.label, value: e.value })
  }

  const onAppChange = (e: any) => {
    if (e === null) setApplication(undefined)
    else setApplication({ label: e.label, value: e.value, id: e.id })
  }

  const onDrop = useCallback(
    async (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
      if (acceptedFiles.length > 0) {
        const totalScreenshots = screenshots.length + acceptedFiles.length
        if (totalScreenshots > 0 && totalScreenshots <= MAX_FILES) {
          const formData = new FormData()
          acceptedFiles.forEach((screenshot: File) => formData.append(screenshot.name, screenshot))
          const screenshotResponse = await postScreeshots({
            url: mapper.userFiles.post,
            data: formData,
            hasFiles: true
          })
          const updatedScreenshots = [...screenshots, ...screenshotResponse]
          setScreenshots(updatedScreenshots)
          if (updatedScreenshots.length > 0) {
            setHasError(false)
            setScreenshotError('')
          }
        } else if (totalScreenshots > MAX_FILES) {
          setHasError(true)
          setScreenshotError(`${Messages.TOO_MANY_FILES} ${MAX_FILES}`)
        }
      }

      if (rejectedFiles.length > 0) {
        setHasError(true)
        switch (rejectedFiles[0].errors[0].code) {
          case 'file-invalid-type': {
            setScreenshotError(Messages.FILE_INVALID_TYPE)
            break
          }
          case 'too-many-files': {
            setScreenshotError(`${Messages.TOO_MANY_FILES} ${MAX_FILES}`)
            console.log(`${Messages.TOO_MANY_FILES} ${MAX_FILES}`)

            break
          }
          default: {
            console.log(rejectedFiles[0].errors[0].message)
            setScreenshotError(rejectedFiles[0].errors[0].message)
          }
        }
      }
    },
    [screenshots]
  )

  const onRemoveScreenshot = (screenshotUrl: string) => {
    const updatedScreenshots = screenshots.filter(({ url }: any) => url !== screenshotUrl)
    setScreenshots(updatedScreenshots)
  }

  const onSubmit = async () => {
    if (option === undefined) setOption(null)
    if (application === undefined) setApplication(null)
    if (option?.label === 'Data Marketplace' && issueCategory === undefined) {
      setIssueCategory(null)
    }

    const isValid = await trigger()
    if (
      isValid &&
      application !== undefined &&
      application !== null &&
      option !== undefined &&
      option !== null &&
      (option?.label !== 'Data Marketplace' ||
        (issueCategory !== undefined && issueCategory !== null))
    ) {
      setDisableButton(true)
      const current_time = moment.utc().format('YYYYDDMM.HHmmssDD')
      const supportId = `SN${current_time}`
      const title = `${supportId} Support Request for ${application?.value} `
      setSupportId(supportId)
      const ticket = {
        title,
        applicationName:
          application?.value === 'Data Marketplace' ? issueCategory?.value : application?.value,
        applicationID: application?.id,
        subject,
        description,
        ...(screenshots.length > 0 && {
          files: screenshots.map(({ name, url }: any) => {
            return {
              name,
              url
            }
          })
        }),
        supportType: 0
      }

      const response = await raiseTicket(ticket)
      if (response.isSuccess) {
        setIsSent(!isSent)
      } else {
        setErrorMessage(
          `Sorry. Seems like we couldn't raise a request right now. Please try again later or reach us at analyticsplatform@mandg.com.`
        )
      }
    }
  }

  return (
    <ContentWrapper>
      {isSent ? (
        <SupportTicket refId={supportId} />
      ) : (
        <Main>
          <div className="ms-3 pt-5">
            <Header>Hi {name?.split(',')[1]},</Header>
            <Header className="mb-2">How can we help you today?</Header>
          </div>
          <StyledCard>
            <h5 className="mx-2 pt-1" style={{ fontWeight: 'bold' }}>
              Contact us
            </h5>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div>
                <div className="form-group col-sm-12 p-1">
                  <Input
                    type="text"
                    id="subject"
                    name="subject"
                    defaultValue={subject}
                    ref={register({ required: true })}
                    invalid={'subject' in errors}
                    placeholder="Subject"
                    onChange={onSubjectChange}
                    helperText={errors.subject ? validationMessages.subject : ''}
                    data-testid="needHelpSubject"
                  />
                </div>
                <div className="form-group col-md-12 p-1 pt-0">
                  <Select
                    placeholder={'What does your query relate to?'}
                    name="select"
                    id="portal"
                    options={options}
                    value={option}
                    theme={selectThemeColors}
                    className={classnames('react-select', {
                      'is-invalid': option === null
                    })}
                    classNamePrefix="select"
                    onChange={onOptionChange}
                    isClearable={true}
                    data-testid="needHelpDropdown"
                  />
                  {option === null && <FormFeedback>Selection is Required.</FormFeedback>}
                </div>
                {option?.label === 'Data Marketplace' && (
                  <div className="form-group col-md-12 p-1 pt-0">
                    <Select
                      placeholder={'Issue category'}
                      name="issueCategory"
                      id="issueCategory"
                      options={issueCategoryOptions}
                      value={issueCategory}
                      theme={selectThemeColors}
                      className={classnames('react-select', {
                        'is-invalid': issueCategory === null
                      })}
                      classNamePrefix="select"
                      onChange={onIssueCategoryChange}
                      isClearable={true}
                      data-testid="issueCategoryDropdown"
                    />
                    {issueCategory === null && (
                      <FormFeedback>Issue category is Required.</FormFeedback>
                    )}
                  </div>
                )}
                {option?.label === 'Specific Application' && (
                  <div className="form-group col-md-12 p-1 pt-0">
                    <Select
                      menuShouldBlockScroll
                      placeholder={'For which application do you need help?'}
                      name="select"
                      id="product"
                      value={application}
                      options={applicationOptions}
                      theme={selectThemeColors}
                      className={classnames('react-select', {
                        'is-invalid': application === null
                      })}
                      classNamePrefix="select"
                      onChange={onAppChange}
                      isClearable={true}
                      data-testid="needHelpProductDropdown"
                    />
                    {application === null && (
                      <FormFeedback>Application Name is Required.</FormFeedback>
                    )}
                  </div>
                )}
                <div className="form-group col-md-12 p-1 pt-0">
                  <Textarea
                    id="description"
                    name="description"
                    ref={register({ required: true })}
                    invalid={'description' in errors}
                    placeholder="Description"
                    onChange={onDescChange}
                    helperText={errors.description ? validationMessages.description : ''}
                    data-testid="needHelpDescription"
                  />
                </div>
                <div className="form-group col-md-12 p-1 pt-0">
                  <Dropzone
                    key={uuid()}
                    onDrop={onDrop}
                    title="Drag and drop screenshots here (max 5)"
                    accept={{
                      'image/jpeg': ['.jpeg', '.png']
                    }}
                    isInvalid={hasError}
                    validationMessage={screenshotError}
                  />
                </div>
                <div className="form-group col-md-12">
                  {isUploadingScreenshots ? (
                    <SpinnerWrapper height="100px">
                      <Spinner />
                    </SpinnerWrapper>
                  ) : (
                    <div className="d-flex flex-wrap p-1 pt-0">
                      {screenshots?.map((screenshot: any, index: number) => {
                        return (
                          <ImgContainer key={index}>
                            <div className="d-flex justify-content-flex-start">
                              <Image
                                className="shadow-sm"
                                key={index}
                                src={appendToken(screenshot.url)}
                              />
                              <div>
                                <a href={appendToken(screenshot.url)}>{screenshot.name}</a>
                                <div>
                                  {moment(screenshot.uploadDate).format('D MMM YYYY HH:mm a')}
                                </div>
                              </div>
                            </div>
                            <Button
                              variant="flat"
                              color="danger"
                              icon={<DeleteIcon />}
                              data-testid="deleteSupportImage"
                              iconOnly={true}
                              onClick={() => onRemoveScreenshot(screenshot.url)}
                              className="rounded-circle"
                            />
                          </ImgContainer>
                        )
                      })}
                    </div>
                  )}
                </div>
              </div>
              <div className="pb-3 mx-1 mt-1">
                <Button
                  label={
                    isSending ? (
                      <>
                        <Spinner size="sm" />
                        &nbsp; Raising ticket
                      </>
                    ) : (
                      'Raise ticket'
                    )
                  }
                  type="submit"
                  color="var(--surface-elevated)"
                  variant="fill"
                  block
                  onClick={onSubmit}
                  disabled={disableButton}
                  data-testid="raiseTicketBtn"
                  //inline style to override global background color class marked important
                  style={{ backgroundColor: 'var(--color-primary) !important' }}
                />
              </div>
              <div className="m-1 px-1 py-1">
                <a
                  href={FAQPage}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline font-semibold">
                  FAQ & Troubleshooting Guide
                </a>
              </div>
            </Form>
          </StyledCard>
          {errorMessage !== '' && (
            <Alert className="m-1 px-1 py-1" color="danger">
              {errorMessage}
            </Alert>
          )}
        </Main>
      )}
    </ContentWrapper>
  )
}

export default SupportForm
